/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){
	function initEventListeners(){

        pipEvents.trackif.trackifSubmitted.off('.trackifSubmitted');
        pipEvents.trackif.trackifSubmitted.on('.trackifSubmitted', function() {
            var obj ={
                category:{
                    primaryCategory: 'button submission'
                },
                eventInfo: {
                    eventName: 'oos notification'
                }
            };
            if(window.digitalData && window.digitalData.event) window.digitalData.event.push(obj);
        })
	}
	return {
		init: function init(){
			initEventListeners();
		}
	}
});

}.call(window));